export const UPDATE_NOTE_ATTRIBUTES = 'UPDATE_NOTE_ATTRIBUTES'
export const CREATE_NOTE = 'CREATE_NOTE'
export const BOOKMARKED_NOTE_IDS_FETCHED = 'BOOKMARK_NOTE_IDS_FETCHED'

export const ARCHIVE_NOTES = 'ARCHIVE_NOTES'
export const ARCHIVED_NOTES = 'ARCHIVED_NOTES'

export const UNARCHIVE_NOTES = 'UNARCHIVE_NOTES'
export const UNARCHIVED_NOTES = 'UNARCHIVED_NOTES'

export const DUPLICATE_NOTE = 'DUPLICATE_NOTE'

export const MOVE_NOTES_TO = 'MOVE_NOTES_TO'
export const MOVED_NOTES_TO = 'MOVED_NOTES_TO'

export const DELETE_NOTES = 'DELETE_NOTES'
export const DELETED_NOTES = 'DELETED_NOTES'

export const SHARE_NOTE_TO_EMAIL = 'SHARE_NOTE_TO_EMAIL'
